import { useEffect, useState } from "react"
import { BotonNuevo } from "../../components/buttons/BotonNuevo"
import { Modal } from "../../components/modal/Modal"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { ContenedorTabla } from "../../components/utils/ContenedorTabla"
import { SearchTable } from "../../components/utils/SearchTable"
import { Tooltip } from "../../components/utils/Tooltip"
import { useEnlaceGruposUID } from "../../../hooks/enlaceGrupos/useEnlaceGruposUID"
import { useUsers } from "../../../hooks/usuarios/useUsers"
import { useCompany } from "../../../hooks/grupos/useCompany"
import { useGroups } from "../../../hooks/grupos/useGroups"
import { SwitchToggle } from "../../components/SwitchToggle"
import { LineaCarga } from "../../components/LineaCarga"

export const EnlaceGrupo = () => {
    const idTablaEnlace = "idTablaEnlace";
    const classNameInput = "text-white h-[30px] rounded caret-white px-2 bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500";
    const [ uidSeleccionado, setUIDSeleccionado ] = useState(0);
    const [ empresaSeleccionada, setEmpresaSeleccionada ] = useState(0)
    const [ checkGrupo, setCheckGrupo ] = useState(false)
    const {
        listarUsuariosPorGrupo,
        usuarioGrupos,
        isOpenModalRegistrarEnlace,
        openModalRegistrarEnlace,
        closeModalRegistrarEnlace,
        usuarioGrupo,
        obtenerDatosUID,
        guardarEditarEnlaceGrupo,
        editarValorUIDGrupo,
        loading

    } = useEnlaceGruposUID()

    const {
        listarUsuariosSinSalaChat,
        usuariosSinSala,
    } = useUsers()

    const {
        listarEmpresa,
        empresas
    } = useCompany()

    const {
        listarGruposPorEmpresaUID,
        gruposEmpresaUid,
        setGruposEmpresaUid

    } = useGroups()

    useEffect(() => {
        listarUsuariosPorGrupo(0)
        listarEmpresa()
    },[])
    
    const registrarEnlace = async (idRoom) => {
        const response = await guardarEditarEnlaceGrupo(usuarioGrupo.UID, idRoom, true)
        if(response){
            listarGruposPorEmpresaUID(usuarioGrupo.UID,usuarioGrupo.codEmpresa)
            listarUsuariosPorGrupo(0)
        }
    }

    const usuariosAgrupados = usuarioGrupos.reduce((acumulador,grupo) => {
        const { CodGrupoDetalle, UID, NomGrupo, IdRoom } = grupo;
        const indiceUID = acumulador.findIndex(item => item.UID === UID);

        if(indiceUID === -1){
            acumulador.push({
                UID,
                cantidadFilas:1,
                grupos:[
                    {IdRoom,NomGrupo,CodGrupoDetalle}
                ]
            });
        }
        else{
            acumulador[indiceUID].grupos.push({IdRoom,NomGrupo,CodGrupoDetalle});
            acumulador[indiceUID].cantidadFilas += 1;
        }
        return acumulador;
    },[]);
    
    return (
        <>
            <ContenedorParametros
                titulo="Asignar grupo"
            >
                <BotonNuevo
                    onClick={async () => {
                        await listarUsuariosSinSalaChat()
                        await obtenerDatosUID()
                        setGruposEmpresaUid([])
                        openModalRegistrarEnlace()
                    }}
                >
                </BotonNuevo>
                <SearchTable tablaId={idTablaEnlace}></SearchTable>
            </ContenedorParametros>
            {loading && <LineaCarga/>}
            <div className='mt-7 relative top-0 bottom-0 left-0 right-0 h-[84vh] overflow-y-auto containerScroll'>
                <table id={idTablaEnlace} className="table">
                    <thead>
                        <tr>
                            <th className="text-left">N</th>
                            <th className="text-left">NOMBRE (UID)</th>
                            <th className="text-left">GRUPO</th>
                            {/* <th></th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            usuariosAgrupados.length > 0 ?
                                usuariosAgrupados.map((u,i) => (
                                   u.grupos.map((detalle,k) =>
                                        (
                                            <>
                                                <tr key={`${i}-${k}`}>
                                                    {
                                                        k === 0 && (
                                                            <>
                                                                <td
                                                                    className="w-[3%]"
                                                                    rowSpan={u.cantidadFilas}
                                                                >{i + 1}</td>
                                                                <td 
                                                                    className=""
                                                                    rowSpan={u.cantidadFilas}
                                                                    onClick={async () => {
                                                                        setGruposEmpresaUid([])
                                                                        await obtenerDatosUID(u)
                                                                        openModalRegistrarEnlace()
                                                                    }}
                                                                >
                                                                    <div className="flex gap-2">
                                                                        <span
                                                                            className="w-[200px] text-ellipsis whitespace-nowrap overflow-hidden"
                                                                        >{u.UID}</span>
                                                                        <i
                                                                            data-tip={u.UID}
                                                                            data-for={u.UID}
                                                                            className=" fa fa-plus-circle text-base text-blue-500"
                                                                        ></i>
                                                                        <Tooltip id={u.UID}>Asignar grupo</Tooltip>
                                                                    </div>
                                                                </td>
                                                            </>
                                                        )
                                                    }
                                                    <td>
                                                        <div className="flex items-center">
                                                            <span className="w-[90%]">{detalle.NomGrupo}</span>
                                                            <i
                                                                className="cursor-pointer fa fa-trash text-red-500 text-base"
                                                                onClick={async () => {
                                                                    const response = await guardarEditarEnlaceGrupo(u.UID, detalle.IdRoom, false)
                                                                    response && listarUsuariosPorGrupo(0)
                                                                }}
                                                            ></i>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    )
                                ))
                            :
                                <tr>
                                    <td colSpan={8} className="text-center">No hay información para mostrar...</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>

            <Modal
                isOpen={isOpenModalRegistrarEnlace}
                closeModal={closeModalRegistrarEnlace}
                title={`${usuarioGrupo.CodGrupoDetalle === 0 ? 'Asignar grupo' : ` Asignar [ ${usuarioGrupo.UID} ] - grupo `}`}
                validButton={{confirm: false,denied: true}}
                textButtons={{denied:'Cancelar'}}
            >
                {
                    isOpenModalRegistrarEnlace &&
                    <>
                        <div className="w-[350px] p-2 flex flex-col">
                                {
                                    usuarioGrupo.CodGrupoDetalle === 0 && 
                                        <>
                                            <label>Usuario</label>
                                            <select 
                                                className={` ${classNameInput}`}
                                                value={usuarioGrupo.UID}
                                                onChange={async (e) => {
                                                    editarValorUIDGrupo('UID',e.target.value)
                                                    usuarioGrupo.codEmpresa !== 0 && listarGruposPorEmpresaUID(uidSeleccionado,empresaSeleccionada)
                                                }}
                                            >
                                                <option key={0} value={0}>--Seleccione--</option>
                                                {
                                                    usuariosSinSala.length > 0 ?
                                                        usuariosSinSala.map((u,i) => (
                                                            <option key={`${u.uid}-${i}`} value={u.uid}>{u.uid}</option>
                                                        ))
                                                        : ''
                                                }
                                            </select>
                                        </>
                                    
                                }
                                <label className="text-left">Empresa</label>
                                <select
                                    className={` ${classNameInput} containerScroll`}
                                    value={usuarioGrupo.codEmpresa}
                                    onChange={async (e) => {
                                        editarValorUIDGrupo('codEmpresa',parseInt(e.target.value))
                                        usuarioGrupo.UID !== '' && listarGruposPorEmpresaUID(usuarioGrupo.UID,parseInt(e.target.value));
                                    }}
                                >
                                    <option value={0} key={0}>--Seleccione--</option>
                                    {
                                        empresas.length > 0 && 
                                            empresas.map((e,i) => (
                                                <option key={e.CodEmpresa} value={e.CodEmpresa}>{e.RazonSocialEmpresa}</option>
                                            ))
                                    }
                                </select>
                            {
                                gruposEmpresaUid.length > 0 && 
                                <div className="pt-3 w-[300px] px-2">
                                    <fieldset className="border text-center rounded p-2">
                                        <legend className="px-[2px]">Seleccionar grupo</legend>
                                            <div className="flex flex-col gap-3 h-[200px] overflow-y-auto containerScroll ">
                                                {
                                                    gruposEmpresaUid.map((g,i) => (
                                                        <div key={i++} className="flex items-center gap-3">
                                                            <span>{g.NomGrupo}</span>
                                                            <button
                                                                className="bg-blue-600 hover:bg-blue-800 w-[80px] h-[35px] px-2 rounded"
                                                                onClick={()=> registrarEnlace(g.IdRoom) }
                                                            >Enlazar</button>
                                                            {/* <SwitchToggle
                                                                valor={g.Pertenece}
                                                                keyEdit={'Pertenece'}
                                                                setEdit={editarValorUIDGrupo}
                                                                funcion={()=> registrarEnlace(g.IdRoom)}
                                                            /> */}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                    </fieldset>
                                </div>
                            }
                        </div>
                    </>
                }

            </Modal>
        </>
    )
}